export default __webpack_public_path__ + "static/PPObjectSans-Regular-43320fb2333a26f07ec0111e597cc2f6.ttf";